// extracted by mini-css-extract-plugin
export default {"grid":"grid--LEy48","name":"name--IozmN","value":"value--Fkf14","demoModeButton":"demoModeButton--nqSEi"};